import abi from "./contract/GlobalPool.json";
import { useState, useEffect } from "react";
import { ethers } from "ethers";
import Buy from "./component/buy";
import Buy1 from "./component/buy1";
import Buy2 from "./component/buy2";
import Memos from "./component/memos";
import "./copy.png";
import Buy3 from "./component/buy3";
import Buy4 from "./component/buy4";



function App() {
  const [state, setState] = useState({
    provider: null,
    signer: null,
    contract: null,
  });
  
  const [account, setAccount] = useState("None");
  const[b,setB]=useState("None");
  const[direct,setDirect]=useState("None");
  const[directs,setDirects]=useState("None");
  const[level,setLevel]=useState("None");
  const[wlevel,setLevelw]=useState("None");
  const[level1,setLevel1]=useState("None");
  const[wlevel1,setLevelw1]=useState("None");
  const[wlevel2,setLevelw2]=useState("None");
  const[plevel,setLevelp]=useState("None");
  const[pack,setpackage]=useState("None");
  const[pack3,setpackage3]=useState("None");
  const[pack1,setpackage1]=useState("None");
  const[refer,setrefer]=useState("None");
  const[refer4,setrefer4]=useState("None");
  const[refer3,setrefer3]=useState("None");
  const[refer1,setrefer1]=useState("None");
  const[refer2,setrefer2]=useState("None");
const [tasks,setTasks] = useState([]);
const [tasks1,setTasks1] = useState([]);
const [tt,settt]=useState("None");
const [tt4,settt4]=useState("None");
const[dd,setDD]=useState("None");
const[dd1,setDD1]=useState("None");
const[dd2,setDD2]=useState("None");
const[referlink,setreflink]=useState("None");
const[bonanza,setBonanza]=useState("None");
const[upd,setupd]=useState("None");
const [tt1,settt1]=useState("None");
const [roi,seroi]=useState("None");
const [roi1,seroi1]=useState("None");
const [roi2,seroi2]=useState("None");
const [a1,sea1]=useState("None");
const [a2,sea2]=useState("None");
const [a3,sea3]=useState("None");
const [tt2,settt2]=useState("None");
const [tt3,settt3]=useState("None");
const[b1,setb1]=useState("None");
const[b2,setb2]=useState("None");
const[b3,setb3]=useState("None");
const[b4,setb4]=useState("None");
const[b5,setb5]=useState("None");
const[b6,setb6]=useState("None");
const[b7,setb7]=useState("None");
const[b8,setb8]=useState("None");
const[b9,setb9]=useState("None");
const[b10,setb10]=useState("None");
const[b11,setb11]=useState("None");
const[b12,setb12]=useState("None");
const[b13,setb13]=useState("None");
const[b14,setb14]=useState("None");
const[b15,setb15]=useState("None");
const[b16,setb16]=useState("None");
const[reward,setreward]=useState("None");
const[reward1,setreward1]=useState("None");
const[reward2,setreward2]=useState("None");
const[reward3,setreward3]=useState("None");
const[reward4,setreward4]=useState("None");
const[reward5,setreward5]=useState("None");
const[reward6,setreward6]=useState("None");
const[reward7,setreward7]=useState("None");
const[reward8,setreward8]=useState("None");
const[reward9,setreward9]=useState("None");
const[reward10,setreward10]=useState("None");

const[x1,setx1]=useState("None");
const[x2,setx2]=useState("None");
const[x3,setx3]=useState("None");
const[x4,setx4]=useState("None");
const[x5,setx5]=useState("None");
const[x6,setx6]=useState("None");
const[x7,setx7]=useState("None");

// ===== SLIDER STATE =====
const [current, setCurrent] = useState(0);
const sliderTotal = 4;
const goTo = (n) => setCurrent((n + sliderTotal) % sliderTotal);

// ===== SLIDER AUTO-PLAY =====
useEffect(() => {
  const timer = setInterval(() => setCurrent(c => (c + 1) % sliderTotal), 5000);
  return () => clearInterval(timer);
}, []);

// ===== SLIDER TRACK SYNC =====
useEffect(() => {
  const track = document.getElementById('slider-track');
  if (track) {
    requestAnimationFrame(() => {
      track.style.transform = `translateX(-${current * 100}%)`;
    });
  }
}, [current]);
  useEffect(() => {
    const connectWallet = async () => {
    const contractAddress = "0x88e578d38616E6c59434B7492FAf04C8FdE4b15b";
    const contractABI = abi.abi;
    const searchParams = new URLSearchParams(window.location.search);
    const myParam = searchParams.get('ref');
    console.log(myParam);
    document.querySelector("#name").value=myParam;
   if(myParam == null)
     {
     document.querySelector("#name").value="0xF75a1f3A248F6bb5926B6B612E0f9FC14a6d9A48";
     }
    try {
    const { ethereum } = window;
  //  document.querySelector("#test").value = "0";
    if (ethereum) {
      const account = await ethereum.request({
        method: "eth_requestAccounts",
      });
     
      window.ethereum.on("chainChanged", () => {
        window.location.reload();
      });

      window.ethereum.on("accountsChanged", () => {
        
        window.location.reload();
      });
          const provider = new ethers.providers.Web3Provider(ethereum);
        
          try {
            const selectedNetwork = await provider.getNetwork();
            if (selectedNetwork.chainId !== 56) {
              await window.ethereum.request({
                method: 'wallet_switchEthereumChain',
                params: [{ chainId: '0x38' }], // Binance Smart Chain Mainnet chainId is 97 in decimal, which is 0x61 in hex
              });
              console.log("You have switched to the Binance network");
            } else {
              console.log("You are already on the Binance network");
            }
          } catch (switchError) {
            // The network has not been added to MetaMask
            if (switchError.code === 4902) {
              console.log("Please add the Binance network to MetaMask");
            } else {
              console.log("Cannot switch to the network");
            }
          }
          const signer = provider.getSigner();
          const contract = new ethers.Contract(
            contractAddress,
            contractABI,
            signer
          );
          setAccount(account);
          setState({ provider, signer, contract });
      let alltasks = await contract.getMemos(account[0]);
      setTasks(alltasks);
       let alltasks1 = await contract.getMemos1(account[0]);
          setTasks1(alltasks1);
      var i = 0;
      document.querySelector("#us").value  = alltasks[13];

      const x5 = Number(alltasks1[2]);
      setx5(x5);
      const x6 = Number(alltasks[20]);
      setx6(x6);

      const refer = (alltasks[1]);
      setrefer(refer);
      const a1 = Number(alltasks[5]);
      sea1(a1);
      const refer2 = (alltasks[23]);
      setrefer2(refer2);
      const x4 = Number(alltasks[19])/1000000000000000000;
      setx4(x4);
      
      document.querySelector("#hid").value  = (alltasks[1]);
      const direct =Number(alltasks[2]);
      setDirect(direct);
      const level = Number(alltasks[4]);
      setLevel(level);
     const plevel = Number(alltasks[21])/1000000000000000000;
     setLevelp(plevel);
     const pack = Number(alltasks[3]) ;
     setpackage(pack);
     document.querySelector("#pp").value  = Number(alltasks[3]);
     const b ='https://bscscan.com/address/'+account;
        
         setB(b);
     const dd = Number(alltasks[9]);
      setDD(dd);
      const reward1 = Number(alltasks[4]);
      setreward1(reward1);
      const reward2 = Number(alltasks[18]);
      setreward2(reward2);
      const reward3 = Number(alltasks[31])/1000000000000000000;
      setreward3(reward3);
      const reward4 =  Number(alltasks[29])/1000000000000000000;
      setreward4(reward4);
      const reward5 =  Number(alltasks[27]);
      setreward5(reward5);
      const reward6 =  Number(alltasks[28]);
      setreward6(reward6);
      const reward7 =  Number(alltasks[29]);
      setreward7(reward7);
      const x1 = (Number(alltasks[17])/1000000000000000000).toFixed(2);
      setx1(x1);
      const x2 = (Number(alltasks[21])/1000000000000000000).toFixed(2);
      setx2(x2);
      const x3 = (Number(alltasks[19])/1000000000000000000).toFixed(2);
      setx3(x3);
      document.querySelector("#tt2").value = tt2;
      const b1 = Number(alltasks[8]) ;
      setb1(b1);
      const b2 = Number(alltasks[9]) ;
      setb2(b2);
      const b3 = Number(alltasks[10]) ;
      setb3(b3);
      const b4 = Number(alltasks[21])/1000000000000000000 ;
      setb4(b4);
      const b5 = Number(alltasks[23])/1000000000000000000 ;
      setb5(b5);
      const b6 = Number(alltasks[24])/1000000000000000000 ;
      setb6(b6);
      const b7 = Number(alltasks[22]) ;
      setb7(b7);
      const b8 = Number(alltasks[26]) ;
      setb8(b8);
      const b9 = Number(alltasks[27]) ;
      setb9(b9);
      const b10 = Number(alltasks[14])/1000000000000000000 ;
      setb10(b10);
      const b11 = Number(alltasks[34])/1000000000000000000 ;
      setb11(b11);
 const wlevel = Number(alltasks[25])/1000000000000000000 ;
 setLevelw(wlevel);
 const wlevel1 = (Number(alltasks[15])/1000000000000000000).toFixed(2);
 setLevelw1(wlevel1);
 const wlevel2 = ((Number(alltasks[16])/1000000000000000000) + (Number(alltasks[15])/1000000000000000000)).toFixed(2);
 setLevelw2(wlevel2);
 const level1 = Number(alltasks[24]);
 setLevel1(level1);
 

     document.querySelector("#wi1").value =  Number(alltasks[15])/1000000000000000000;
     document.querySelector("#roi").value =  Number(alltasks[3]);
     
    // const a1 = Number(alltasks1[0])-1;
          
    // sea1(a1);
     const a3 = Number(alltasks[7]);
          
    sea3(a3);
     const a2 = Number(alltasks[6]);
    sea2(a2);   
     var rr = 0;
    // const tt4 =  Number(alltasks[15])/1000000000000000000;
    // settt4(tt4);
     
const tt =  (Number(alltasks[16])/1000000000000000000).toFixed(2);
     settt(tt);
     
const pack1 = ((Number(alltasks[16])/1000000000000000000) + (Number(alltasks[3]))).toFixed(2);

setpackage1(pack1);

     const tt3 = Number(alltasks[10])/1000000000000000000;
     settt3(tt3);
     document.querySelector("#bal").value = tt3;
     const referlink = 'https://www.alfafinancial.xyz/?ref='+ account;
     setreflink(referlink);
     document.querySelector("#link").value =referlink;
if(x6==0)
{
      const x7 = "Starter";
      setx7(x7);
}
if(x6==1)
{
      const x7 = "Spark";
      setx7(x7);
}
if(x6==2)
{
      const x7 = "Velocity";
      setx7(x7);
}
if(x6==3)
{
      const x7 = "Titan";
      setx7(x7);
}
if(x6==4)
{
      const x7 = "Infinity";
      setx7(x7);
}
if(x6==5)
{
      const x7 = "Legacy";
      setx7(x7);
}

     const upd = b1+b2+b3+b4+b5+b6+b7+b8+b9+b10+b11+b12+b13+b14+b15;
          
     setupd(upd);


console.log(pack);

  const dd2 = Number(alltasks[25]?.toString?.() || alltasks[30]);
setDD2(dd2);

const dd1 = Math.floor(Date.now() / 1000);
setDD1(dd1);

// remaining seconds (24 hours)
const totalSeconds = Math.max(0, 86400 - (dd1 - dd2));

// convert to hh:mm:ss
const hours = Math.floor(totalSeconds / 3600);
const minutes = Math.floor((totalSeconds % 3600) / 60);
const seconds = totalSeconds % 60;

const formattedTime =
  String(hours).padStart(2, "0") + ":" +
  String(minutes).padStart(2, "0") + ":" +
  String(seconds).padStart(2, "0");

settt2(formattedTime);
        } else {
          alert("Please install metamask");
        }
      } catch (error) {
        console.log(error);
      }
    };
    
   
    
    connectWallet();
    
    function myFunction() {
      
      var copyText = "hello";
      copyText.select();
      copyText.setSelectionRange(0, 99999); // For mobile devices
      
    
      // Copy the text inside the text field
      navigator.clipboard.writeText(copyText.valueOf);
    }
  document.body.style.backgroundColor = 'black';
  }, []);

 
  // console.log(state);
  return (
  <div>
    <input type="hidden" id ="link"></input>
    <input type="hidden" id ="hid"></input>
    <input type="hidden" id ="us"></input>
    <input type="hidden" id ="pp"></input>
    <input type="hidden" id ="tt2"></input>
    <input type="hidden" id ="wi1"></input>
    <input type="hidden" id ="roi"></input>
    <input type="hidden" id ="bal"></input>
 <div style={{ 
    WebkitOverflowScrolling: 'touch',
    overflowY: 'auto',
  
    position: 'relative'   // ADD THIS
  }}></div>
   
      <header style={{ height: "8rem" }} className="topnav" id="topnav">
      <div style={{ display: "flex", justifyContent: "center" }} className="nav-container">
        <a href="#" className="nav-logo">
          <div className="logo-icon">
            <img src="logo.png" alt="Alfa Logo" className="logo-img" />
          </div>
        </a>
      </div>
    </header>
     <div className="floating-buttons">
  <a
    href="https://t.me/alfafinancialltd"
    target="_blank"
    rel="noopener noreferrer"
    className="float-btn telegram-btn"
    title="Join Telegram"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
    </svg>
    <span>Alfa</span>
  </a>

  <a
    href={b}   
     target="_blank"
    rel="noopener noreferrer"
    className="float-btn history-btn"
    title="My History"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 3v5h5" />
      <path d="M3.05 13A9 9 0 1 0 6 5.3L3 8" />
      <path d="M12 7v5l4 2" />
    </svg>
    <span>My History</span>
  </a>
</div>
    <main style={{ marginTop: "5rem" }} className="main-content">
      <div className="dashboard-container">

        {/* ── ROW 1: Welcome + Hero Banner ── */}
        <section className="row-welcome-hero">

          {/* Welcome Card */}
          <div className="welcome-card glass-card">
            <div className="company-header">

   
    <div
  style={{
    display: "flex",
    alignItems: "center",
    gap: "25px",
    marginBottom: "30px",
    flexWrap: "wrap",
  }}
>
  

  {/* Content */}
  <div
    style={{
      flex: 1,
      minWidth: "280px",
    }}
  >
    <span
      style={{
        display: "inline-block",
        background: "#d1fae5",
        color: "#047857",
        padding: "6px 14px",
        borderRadius: "30px",
        fontSize: "12px",
        fontWeight: "700",
        letterSpacing: "1px",
        marginBottom: "15px",
      }}
    >
      ● ACTIVE INVESTMENT PLATFORM
    </span>

    <h2
      style={{
        fontSize: "34px",
        fontWeight: "700",
        margin: "15px 0 0",
        color: "#ffffff",
      }}
    >
      Alfa Financial Limited
    </h2>

    <p
      style={{
        marginTop: "15px",
        color: "rgba(255,255,255,0.75)",
        lineHeight: "1.7",
        maxWidth: "600px",
        fontSize: "16px",
      }}
    >
      A next-generation financial platform committed to secure investments,
      sustainable growth and long-term wealth creation for every member.
    </p>

    <div
      style={{
        display: "flex",
        gap: "12px",
        flexWrap: "wrap",
        marginTop: "20px",
      }}
    >
      {[
        "🚀 Innovation",
        "🔒 Secure",
        "📈 Growth",
        "🌍 Global",
      ].map((item) => (
        <div
          key={item}
          style={{
            padding: "12px 18px",
            background: "rgba(255,255,255,0.08)",
            border: "1px solid rgba(255,255,255,0.15)",
            borderRadius: "12px",
            color: "#fff",
            fontWeight: "600",
            fontSize: "14px",
            backdropFilter: "blur(8px)",
            WebkitBackdropFilter: "blur(8px)",
          }}
        >
          {item}
        </div>
      ))}
    </div>
  </div>
</div>

</div>
            {/* Stat Cards Grid */}
           <div style={{
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 200px), 1fr))',
  gap: '16px',
  width: '100%'
}}>
  <div className="stat-card stat-blue" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
    <div className="stat-icon">🌍</div>
    <div>
      <p className="stat-label">My Fund value</p>
      <p className="stat-value">{pack1}</p>
    </div>
  </div>

  <div className="stat-card stat-purple" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
    <div className="stat-icon">💵</div>
    <div>
      <p className="stat-label">My Investment</p>
      <p className="stat-value">{pack}</p>
    </div>
  </div>

  <div className="stat-card stat-orange" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
    <div className="stat-icon">🚀</div>
    <div>
      <p className="stat-label">Total Income</p>
      <p className="stat-value">{wlevel2}</p>
    </div>
  </div>

  <div className="stat-card stat-green" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
    <div className="stat-icon">🔒</div>
    <div>
      <p className="stat-label">My Investment</p>
      <p className="stat-value">{pack}</p>
    </div>
  </div>
</div>

            {/* Level Progress */}
           
          </div>

         <div  className="hero-banner glass-card">
 <div
  style={{
    maxWidth: "650px",
    color: "#fff",
    padding: "20px 0",
  }}
>
  <span
    style={{
      display: "inline-block",
      padding: "8px 18px",
      background: "rgba(37,99,235,0.15)",
      color: "#60a5fa",
      border: "1px solid rgba(96,165,250,0.35)",
      borderRadius: "30px",
      fontSize: "13px",
      fontWeight: "700",
      letterSpacing: "1px",
      textTransform: "uppercase",
      marginBottom: "20px",
    }}
  >
    PREMIUM INVESTMENT PLATFORM
  </span>

  <h1
    style={{
      fontSize: "36px",
      fontWeight: "800",
      lineHeight: "1.15",
      margin: "20px 0",
      color: "#ffffff",
    }}
  >
    Unlock Financial Opportunities
  </h1>

  <p
    style={{
      fontSize: "18px",
      lineHeight: "1.8",
      color: "rgba(255,255,255,0.75)",
      maxWidth: "600px",
      marginTop: "15px",
    }}
  >
    Experience secure investing, transparent earnings, and long-term wealth
    creation through Alfa Financial Limited.
  </p>
</div>

  <div className="action-buttons" style={{
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 160px), 1fr))",
  gap: "14px",
  marginTop: "1.5rem"
}}>
   
    <div style={{
     background: "linear-gradient(135deg, #1e3a8a, #2563eb)",
      border: "1px solid rgba(139,92,246,0.5)",
      borderRadius: "14px",
      padding: "16px",
      display: "flex",
      flexDirection: "column",
      gap: "10px"
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none"  stroke="#93c5fd" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <path d="M12 19V5"/>
  <path d="M5 12l7-7 7 7"/>
</svg>
       
        <span style={{ color: "#93c5fd", fontWeight: "600", fontSize: "0.95rem" }}>Register</span>
      </div>
      
     
      
     <Buy2 state={state} /> 
    </div>
     
     
    <div style={{
    background: "linear-gradient(135deg, #064e3b, #059669)",
      border: "1px solid rgba(34,197,94,0.5)",
      borderRadius: "14px",
      padding: "16px",
      display: "flex",
      flexDirection: "column",
      gap: "10px"
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#4ade80" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <circle cx="9" cy="21" r="1"/>
  <circle cx="20" cy="21" r="1"/>
  <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
</svg>
       
        <span style={{ color: "#4ade80", fontWeight: "600", fontSize: "0.95rem" }}>Buy Package</span>
      </div>
      <input
       id="amt" type="text"  placeholder="Enter amount" 
        style={{
          width: "100%",
          padding: "8px 12px",
          borderRadius: "8px",
          border: "1px solid rgba(34,197,94,0.5)",
          background: "rgba(34,197,94,0.1)",
          color: "white",
          fontSize: "0.75rem",
          outline: "none",
          boxSizing: "border-box",
          cursor: "pointer"
        }}
       
      />
     
       <Buy state={state} />
    
    </div>
    
    <div style={{
    background: "linear-gradient(135deg, #164e63, #0891b2)",
      border: "1px solid rgba(20,184,166,0.5)",
      borderRadius: "14px",
      padding: "16px",
      display: "flex",
      flexDirection: "column",
      gap: "10px"
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#2dd4bf" strokeWidth="2">
          <rect x="2" y="5" width="20" height="14" rx="2" />
          <path d="M2 10h20" />
        </svg>
        <span style={{ color: "#2dd4bf", fontWeight: "600", fontSize: "0.95rem" }}>Withdrawal</span>
      </div>
      <input type="text" id="test" placeholder="Enter amount"   style={{
          width: "100%",
          padding: "8px 12px",
          borderRadius: "8px",
          border: "1px solid rgba(34,197,94,0.5)",
          background: "rgba(34,197,94,0.1)",
          color: "white",
          fontSize: "0.75rem",
          outline: "none",
          boxSizing: "border-box",
          cursor: "pointer"
        }} />
      <Buy3 state={state} />
    
    
    </div>

    {/* Withdraw */}
    <div style={{
      background: "linear-gradient(135deg, #78350f, #d97706)",
      border: "1px solid rgba(249,115,22,0.5)",
      borderRadius: "14px",
      padding: "16px",
      display: "flex",
      flexDirection: "column",
      gap: "10px"
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <svg  width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fb923c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <rect x="3" y="8" width="18" height="13" rx="2"/>
  <path d="M12 8v13"/>
  <path d="M3 12h18"/>
  <path d="M12 8s-2-3-4-3-2 3-2 3"/>
  <path d="M12 8s2-3 4-3 2 3 2 3"/>
</svg>
        <span style={{ color: "#fb923c", fontWeight: "600", fontSize: "0.95rem" }}>Lucky Draw</span>
      </div>
     <h3 className="scanner-title-2">Buy Lucky Draw</h3>
                <p className="scanner-desc"><input  type="hidden" id="test" placeholder="Enter amount" /></p>
                 <Buy4 state={state} />
    </div>

     
    <div style={{
     background: "linear-gradient(135deg, #831843, #f286b7)",
      border: "1px solid rgba(34,197,94,0.5)",
      borderRadius: "14px",
      padding: "16px",
      display: "flex",
      flexDirection: "column",
      gap: "10px"
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fbcfe8" strokeWidth="2">
          <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" />
        </svg>
        <span style={{ color: "#fbcfe8", fontWeight: "600", fontSize: "0.95rem" }}>Trade</span>
      </div>
      <input
       type="hidden" id="test"  placeholder="Enter amount" 
        style={{
          width: "100%",
          padding: "8px 12px",
          borderRadius: "8px",
          border: "1px solid rgba(34,197,94,0.5)",
          background: "rgba(34,197,94,0.1)",
          color: "white",
          fontSize: "0.75rem",
          outline: "none",
          boxSizing: "border-box",
          cursor: "pointer"
        }}
       
      />
     
       <Buy1 state={state} />
    
    </div>

    <div
  style={{
    background: "linear-gradient(135deg, #581c87, #a855f7)",
    border: "1px solid rgba(168,85,247,0.6)",
    borderRadius: "14px",
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    gap: "10px"
  }}
>
  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#f3e8ff"
      strokeWidth="2"
    >
      <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" />
    </svg>

    <span
      style={{
        color: "#f3e8ff",
        fontWeight: "600",
        fontSize: "0.95rem"
      }}
    >
    Next trade in
    </span>
   
  </div>
 {tt2}
 


</div>
    
    <div
  style={{
    background: "linear-gradient(135deg, #7f1d1d, #dc2626)",
border: "1px solid rgba(248,113,113,0.6)",
boxShadow: "0 4px 15px rgba(220,38,38,0.3)",
    borderRadius: "14px",
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    boxShadow: "0 4px 15px rgba(220,38,38,0.3)"
  }}
>
  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#fecaca"
      strokeWidth="2"
    >
      <rect x="2" y="5" width="20" height="14" rx="2" />
      <path d="M2 10h20" />
    </svg>

    <span
      style={{
        color: "#fecaca",
        fontWeight: "600",
        fontSize: "0.95rem"
      }}
    >
      My Rank :
    </span>
  </div>

  {x7}
</div>


  </div>
</div>

         
        </section>

       

        {/* ── ROW 3: Package + Team + Activities ── */}
        <section className="row-three-cols">

          {/* Package Progress */}
         
        <div className="team-card glass-card">
            <h3 className="card-title">Income</h3>
            <div className="team-grid">
              <div className="team-stat">
                <div className="team-icon t-purple">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
  <path d="M21 7H5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h16V7z"/>
  <path d="M16 12h4"/>
  <path d="M3 7V5a2 2 0 0 1 2-2h13"/>
</svg>
                </div>
                <p className="team-num">{wlevel2} </p>
                <p className="team-lbl">Total Income</p>
              </div>
              <div className="team-stat">
                <div className="team-icon t-orange">
                 <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
  <ellipse cx="12" cy="5" rx="7" ry="3"/>
  <path d="M5 5v6c0 1.7 3.1 3 7 3s7-1.3 7-3V5"/>
  <path d="M5 11v6c0 1.7 3.1 3 7 3s7-1.3 7-3v-6"/>
</svg>
                </div>
                <p className="team-num"> {tt} USDT</p>
                <p className="team-lbl"> PENDING INCOME</p>
              </div>
                <div className="team-stat">
                <div className="team-icon t-orange">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
                    <circle cx="9" cy="7" r="4" />
                    <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" />
                  </svg>
                </div>
                <p className="team-num">{x1} USDT</p>
                <p className="team-lbl">  Personal Growth Income</p>
              </div>
              
              <div className="team-stat">
                <div className="team-icon t-green">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10" />
                    <polyline points="12 6 12 12 16 14" />
                  </svg>
                </div>
                <p className="team-num">{x3}</p>
                <p className="team-lbl">Level Income</p>
              </div>
               
           
              
            </div>
          </div>
          {/* Team Overview */}
          <div className="team-card glass-card">
            <h3 className="card-title">Level Team</h3>
            <div className="team-grid">
              <div className="team-stat">
                <div className="team-icon t-purple">
                 <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
  <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/>
  <polyline points="17 6 23 6 23 12"/>
</svg>
                </div>
                <p className="team-num"> {a1}</p>
                <p className="team-lbl">Level 1</p>
              </div>
              <div className="team-stat">
                <div className="team-icon t-orange">
                 <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
  <rect x="3" y="8" width="18" height="13"/>
  <path d="M12 8v13"/>
  <path d="M3 12h18"/>
  <path d="M12 8c-2-3-6-4-6-1s3 3 6 1z"/>
  <path d="M12 8c2-3 6-4 6-1s-3 3-6 1z"/>
</svg>
                </div>
                <p className="team-num">{a2}</p>
                <p className="team-lbl">Level 2</p>
              </div>
              <div className="team-stat">
                <div className="team-icon t-blue">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2" />
                    <circle cx="9" cy="7" r="4" />
                    <line x1="19" y1="8" x2="19" y2="14" />
                    <line x1="22" y1="11" x2="16" y2="11" />
                  </svg>
                </div>
                <p className="team-num">{a3} </p>
                <p className="team-lbl"> Level 3</p>
              </div>
              
            </div>
          </div>
            <div className="team-card glass-card">
            <h3 className="card-title">Active Level Team</h3>
            <div className="team-grid">
              <div className="team-stat">
                <div className="team-icon t-purple">
<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
  <rect x="3" y="3" width="6" height="6"/>
  <rect x="15" y="3" width="6" height="6"/>
  <rect x="3" y="15" width="6" height="6"/>
  <rect x="15" y="15" width="6" height="6"/>
  <path d="M9 6h6M6 9v6M18 9v6M9 18h6"/>
</svg>
                </div>
                <p className="team-num"> {b1}</p>
                <p className="team-lbl">Level 1</p>
              </div>
              <div className="team-stat">
                <div className="team-icon t-orange">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
</svg>
                </div>
                <p className="team-num">{b2}</p>
                <p className="team-lbl">Level 2</p>
              </div>
              <div className="team-stat">
                <div className="team-icon t-blue">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2" />
                    <circle cx="9" cy="7" r="4" />
                    <line x1="19" y1="8" x2="19" y2="14" />
                    <line x1="22" y1="11" x2="16" y2="11" />
                  </svg>
                </div>
                <p className="team-num">{b3} </p>
                <p className="team-lbl"> Level 3</p>
              </div>
              
            </div>
          </div>
           <div className="team-card glass-card">
            <h3 className="card-title">Level Business</h3>
            <div className="team-grid">
              <div className="team-stat">
                <div className="team-icon t-purple">
                 <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
  <path d="M8 21h8"/>
  <path d="M12 17v4"/>
  <path d="M7 4h10v6a5 5 0 0 1-10 0V4z"/>
  <path d="M5 4H3v3a3 3 0 0 0 3 3"/>
  <path d="M19 4h2v3a3 3 0 0 1-3 3"/>
</svg>
                </div>
                <p className="team-num">{b7} USDT</p>
                <p className="team-lbl">Level 1 Business</p>
              </div>
              <div className="team-stat">
                <div className="team-icon t-orange">
                 <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
  <circle cx="12" cy="12" r="9"/>
  <circle cx="12" cy="12" r="4"/>
</svg>
                </div>
                <p className="team-num">{b8} USDT</p>
                <p className="team-lbl">Level 2 Business</p>
              </div>
              <div className="team-stat">
                <div className="team-icon t-blue">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2" />
                    <circle cx="9" cy="7" r="4" />
                    <line x1="19" y1="8" x2="19" y2="14" />
                    <line x1="22" y1="11" x2="16" y2="11" />
                  </svg>
                </div>
                <p className="team-num">{b9} USDT</p>
                <p className="team-lbl"> Level 3 Business</p>
              </div>
              
            </div>
          </div>
           <div className="team-card glass-card">
            <h3 className="card-title">Direct Income</h3>
            <div className="team-grid">
              <div className="team-stat">
                <div className="team-icon t-purple">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
  <rect x="3" y="3" width="6" height="6"/>
  <rect x="15" y="3" width="6" height="6"/>
  <rect x="3" y="15" width="6" height="6"/>
  <rect x="15" y="15" width="6" height="6"/>
  <path d="M9 6h6M6 9v6M18 9v6M9 18h6"/>
</svg>
                </div>
                <p className="team-num">{b4} USDT</p>
                <p className="team-lbl">Level 1 </p>
              </div>
              <div className="team-stat">
                <div className="team-icon t-orange">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
                    <circle cx="9" cy="7" r="4" />
                    <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" />
                  </svg>
                </div>
                <p className="team-num">{b5} USDT</p>
                <p className="team-lbl">Level 2 </p>
              </div>
              <div className="team-stat">
                <div className="team-icon t-blue">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2" />
                    <circle cx="9" cy="7" r="4" />
                    <line x1="19" y1="8" x2="19" y2="14" />
                    <line x1="22" y1="11" x2="16" y2="11" />
                  </svg>
                </div>
                <p className="team-num">{b6} USDT</p>
                <p className="team-lbl"> Level 3 </p>
              </div>
              
            </div>
          </div>
           <div className="team-card glass-card">
            <h3 className="card-title">Lucky Draw & Rewards</h3>
            <div className="team-grid">
              <div className="team-stat">
                <div className="team-icon t-purple">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
                    <circle cx="9" cy="7" r="4" />
                    <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" />
                  </svg>
                </div>
                <p className="team-num">{reward1}</p>
                <p className="team-lbl">Current Lucky Draw </p>
              </div>
              <div className="team-stat">
                <div className="team-icon t-orange">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
                    <circle cx="9" cy="7" r="4" />
                    <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" />
                  </svg>
                </div>
                <p className="team-num">{reward2} </p>
                <p className="team-lbl">Total Lucky Draw<br></br> Participations </p>
              </div>
              <div className="team-stat">
                <div className="team-icon t-blue">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2" />
                    <circle cx="9" cy="7" r="4" />
                    <line x1="19" y1="8" x2="19" y2="14" />
                    <line x1="22" y1="11" x2="16" y2="11" />
                  </svg>
                </div>
                <p className="team-num">{reward3}</p>
                <p className="team-lbl"> Lucky Draw</p>
              </div>
                 <div className="team-stat">
                <div className="team-icon t-purple">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
                    <circle cx="9" cy="7" r="4" />
                    <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" />
                  </svg>
                </div>
                <p className="team-num">{reward4}</p>
                <p className="team-lbl">Reward</p>
              </div>
            </div>
          </div>
              <div className="team-stat">
                <div className="team-icon t-green">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10" />
                    <polyline points="12 6 12 12 16 14" />
                  </svg>
                </div>
                <p className="team-num">{wlevel1}</p>
                <p className="team-lbl"> TOTAL WITHDRAWL</p>
              </div>
               <div className="team-stat">
                <div className="team-icon t-green">
                 <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
  <polyline points="3 17 9 11 13 15 21 7"/>
  <polyline points="14 7 21 7 21 14"/>
</svg>
                </div>
                <p className="team-num"></p>
                 <p style={{ wordBreak: "break-all", fontSize: "0.8rem" }}   className="team-num">{refer}</p>
                <p className="team-lbl"> My Referer</p>
              </div>
              

       
          {/* Mission / Referral */}
          <div className="mission-card glass-card">
            <div className="mission-content">
              <h3 className="card-title">My Referlink</h3>
              <p className="mission-text" style={{ wordBreak: "break-all", fontSize: "0.8rem" }}>
                {referlink}
              </p>
              <button
                className="learn-btn"
                onClick={() => navigator.clipboard.writeText(referlink)}
              >
                Copy Link
              </button>
             
            </div>
            <div className="mission-visual">
              <div className="mission-glow"></div>
              <img src="3.png" alt="Mission" className="mission-img" />
            </div>
          </div>

          {/* Token & Rewards */}
         
        </section>

        {/* ── CTA Banner ── */}
        <section className="cta-banner glass-card">
          <div className="cta-left">
           
            
          </div>
          <div className="cta-left">
            <h2 className="cta-title"> My Account</h2>
            <p className="cta-sub" style={{ wordBreak: "break-all", fontSize: "0.8rem" }}>
              {account}
            </p>
            
          </div>
          <div className="cta-icons">
            <div className="cta-icon-item">
              <div className="cta-icon-wrap">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="5" y="2" width="14" height="20" rx="2" />
                  <line x1="12" y1="18" x2="12.01" y2="18" />
                </svg>
              </div>
              <p>Secure Platform</p>
            </div>
            <div className="cta-icon-item">
              <div className="cta-icon-wrap">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="12" y1="8" x2="12" y2="12" />
                  <line x1="12" y1="16" x2="12.01" y2="16" />
                </svg>
              </div>
              <p>Instant Payout</p>
            </div>
            <div className="cta-icon-item">
              <div className="cta-icon-wrap">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="2" y1="12" x2="22" y2="12" />
                  <path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z" />
                </svg>
              </div>
              <p>Global Access</p>
            </div>
            <div className="cta-icon-item">
              <div className="cta-icon-wrap">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 11.5a19.79 19.79 0 01-3.07-8.67A2 2 0 012 .84h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 8.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" />
                </svg>
              </div>
              <p>24/7 Support</p>
            </div>
          </div>
        </section>

      </div>
    </main>

    {/* Footer */}
    <footer className="site-footer">
      <div className="footer-container">
        <p className="footer-copy">© 2026 Alfa Financial Limited. All rights reserved.</p>
        <div className="footer-links">
         
        </div>
        <div className="footer-socials">
          <a href="#" className="social-icon" aria-label="WhatsApp">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
              <path d="M12 0C5.373 0 0 5.373 0 12c0 2.124.552 4.122 1.518 5.861L.057 23.998l6.299-1.652A11.934 11.934 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.879 0-3.638-.491-5.164-1.349l-.37-.22-3.838 1.006 1.024-3.736-.241-.383A9.96 9.96 0 012 12c0-5.514 4.486-10 10-10s10 4.486 10 10-4.486 10-10 10z" />
            </svg>
          </a>
          <a href="#" className="social-icon" aria-label="Telegram">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M11.944 0A12 12 0 000 12a12 12 0 0012 12 12 12 0 0012-12A12 12 0 0012 0a12 12 0 00-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 01.171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
            </svg>
          </a>
          <a href="#" className="social-icon" aria-label="YouTube">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M23.495 6.205a3.007 3.007 0 00-2.088-2.088c-1.87-.501-9.396-.501-9.396-.501s-7.507-.01-9.396.501A3.007 3.007 0 00.527 6.205a31.247 31.247 0 00-.522 5.805 31.247 31.247 0 00.522 5.783 3.007 3.007 0 002.088 2.088c1.868.502 9.396.502 9.396.502s7.506 0 9.396-.502a3.007 3.007 0 002.088-2.088 31.247 31.247 0 00.5-5.783 31.247 31.247 0 00-.5-5.805zM9.609 15.601V8.408l6.264 3.602z" />
            </svg>
          </a>
          <a href="#" className="social-icon" aria-label="Twitter">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
            </svg>
          </a>
        </div>
      </div>
    </footer>







   </div> 
  );
}

export default App;
